var syncing = false;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.mrk_money_format;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// product page logic start here

function buildRequestUrl() {
  const _this = $('frame-variant-picker');
  if ($(_this).length == 0) { return }
  const selectedOption = $('frame-variant-picker input:checked'); // Get the checked input
  const optionValueId = selectedOption.data('option-value-id'); // Get its data-option-value-id

  if (!optionValueId) {
    return; // If no option value ID is found, return nothing
  }

  const productUrl = $(_this).data('product-url');

  // Resolve the section id. On the PDP it comes from the .shopify-section
  // ancestor and is the FULL id (e.g. "template--123__main"). Inside the
  // quick-add modal there is no such ancestor, so quick-add.js captures the
  // real id from the fetched page into window.mrkQuickAddSectionId.
  // NOTE: the bare key "main" 404s for this param - only the full id works -
  // so when we can't resolve a full id we omit section_id entirely and let the
  // full ?view=frame page render (still returns the frame picker).
  const $section = $(_this).parents('.shopify-section');
  var section_id = '';
  if ($section.length && $section.attr('id')) {
    section_id = $section.attr('id').replace('shopify-section-', '');
  } else if (window.mrkQuickAddSectionId) {
    // Quick-add modal: use the full section id captured from the fetched page so
    // the frame picker re-renders through the SAME ?view=frame path as the PDP.
    // (It previously used ?view=quick-view, which resolves the MAIN product from
    // a FRAME option-value id - a mismatch - so the picker never updated on a
    // size change. option_values here is a frame-product option value, so it
    // only makes sense in the frame view.)
    section_id = window.mrkQuickAddSectionId;
  }

  if (section_id) {
    return `${productUrl}?section_id=${section_id}&option_values=${optionValueId}&view=frame`;
  }
  return `${productUrl}?option_values=${optionValueId}&view=frame`;
}
function updatePrices(prices) {
  var final_price = 0;
  var final_Compare_at_price = 0;
  prices.map(p => {
    final_price = final_price + p.price;
    final_Compare_at_price = final_Compare_at_price + p.compare_price;
  });
  var discount = (final_Compare_at_price - final_price) * 100 / final_Compare_at_price;
  var $own = droolOwnPriceTargets();
  $own('.mrk-discount-percent').html(discount.toFixed(0));
  $own('.mrk-main-price').html(Shopify.formatMoney(final_price));
  $own('.mrk-main-compare-price').html(Shopify.formatMoney(final_Compare_at_price));
  // Daily offer price (docs/daily-offer.md): the same total with the offer's extra off on the print
  // only (wd_offer); frame and framing service are not in the offer. snippets/price.liquid prints
  // .wd-offer-price for offer products and the bar's CSS decides which of the two shows.
  var wd_offer_api = window.droolDailyOffer;
  // Only the price block's own pair ([ref="priceContainer"]): the size rows carry .wd-offer-price
  // too, each with its own size's price.
  if (wd_offer_api && wd_offer_api.discountCents && $own('[ref="priceContainer"] .wd-offer-price').length) {
    var wd_offer_total = 0;
    prices.map(p => {
      wd_offer_total = wd_offer_total + (p.wd_offer ? wd_offer_api.discountCents(p.price) : p.price);
    });
    $own('[ref="priceContainer"] .wd-offer-price').html(Shopify.formatMoney(wd_offer_total));
  }
  if (discount > 0) {
    $own('.mrk-sale-badge-wrapper').show();
    $own('.mrk-main-compare-price').show();
  } else {
    $own('.mrk-sale-badge-wrapper').hide();
    $own('.mrk-main-compare-price').hide();
  }
}
// The price elements of the product being configured, for updatePrices(): inside the quick view
// while it is open (quick-add.js opens the dialog before it injects the product), otherwise the
// page without the quick view — and never a product card. Every price on the site renders
// snippets/price.liquid, so cards carry the same .mrk-main-price / .mrk-main-compare-price
// classes: a page-wide write repriced every collection and recommendation card with the
// configured product, and a quick view repriced the product page behind it.
function droolOwnPriceTargets() {
  var quickViewOpen = !!document.querySelector('#quick-add-dialog dialog[open]');
  return function (selector) {
    return $(selector).filter(function () {
      if ($(this).closest('product-card, .resource-card').length) return false;
      return $(this).closest('#quick-add-dialog').length ? quickViewOpen : !quickViewOpen;
    });
  };
}
function RemoveUnavailableVariants() {
  if (window.availableFrameIDs && window.availableFrameIDs.length) {
    const $childFrames = $('.mrk-child-frame-item');
    // window.availableFrameIDs is a PAGE global, built from the CURRENT product's
    // custom.child_frames metafield (snippets/mrk-global-veriables.liquid). Inside the quick-add
    // modal it can still hold the HOST product's ids - so for a print whose frame product differs
    // (e.g. a `frame-1` print opened from a `classic-frame` page) NOTHING matches and the loop
    // below deleted every colour swatch, leaving only the separately-rendered "Unframed" one.
    // Removing all of them is never a valid outcome, so treat "no match at all" as "this list
    // isn't for this picker" and leave the swatches untouched. When the list DOES belong to this
    // picker, filtering below is unchanged.
    let anyMatch = false;
    $childFrames.each(function () {
      if (window.availableFrameIDs.includes(Number($(this).attr('variant-id')))) anyMatch = true;
    });
    if (!anyMatch) return;
    $childFrames.each(function () {
      const variantId = Number($(this).attr('variant-id'));
      if (!window.availableFrameIDs.includes(variantId)) {
        $(this).remove();
      }
    });
    // NOTE: arrow visibility is NOT decided here anymore. The old ">3 child
    // frames" count set an inline display on the arrows container, which fought
    // (and beat) the real-overflow logic in refreshSwatchOverflow - e.g. 3
    // frames + the "Unframed" swatch = 4 items that overflow and DO need arrows,
    // yet the count said "hide". refreshSwatchOverflow is now the single source
    // of truth, driven by actual overflow.
  }

}
function getMainParentVariant(main_variant) {
  // Some products (e.g. simple/framed-print-only variants surfaced in the
  // quick-add modal) have no checked frame switcher, so .val() is undefined.
  // Bail out to the variant we were given rather than crashing on .toLowerCase().
  var checked_frame = $('.mrk-frame-switcher input:checked').val();
  if (!checked_frame) return main_variant;
  // frame-color is `frame.title | handleize` ("dark-oak"), so the chosen value is handleized the same
  // way. Lowercasing alone never matched a multi-word colour ("dark oak").
  var frame_swatch = $(`variant-picker [frame-color="${checked_frame.toLowerCase().trim().replace(/\s+/g, '-')}"]`).val();
  var parent = (window.main_product_data || []).find(v =>
    v.option1 === main_variant.option1 &&
    v.option2 === frame_swatch
  );
  // Never return undefined - callers assign this back to main_variant and then
  // read main_variant.price/.id.
  return parent || main_variant;
}
// Sizes with no standalone frame in stock: the print can be bought framed, but the framing
// service must not be removable (nothing to ship unassembled). Ids come from the variant
// metafield custom.framing_service_locked via window.framing_service_locked_variant_ids
// (snippets/mrk-global-veriables.liquid). Empty list = no lock, behaviour unchanged.
function isFramingServiceLocked(main_variant) {
  if (!main_variant || main_variant.id == null) return false;
  var ids = (window.framing_service_locked_variant_ids || []).map(String);
  if (ids.indexOf(String(main_variant.id)) > -1) return true;
  // The mark can also sit on the print's built-in framed variant ("A4 / Framed black"). On a print
  // with child frames the selected variant is always the unframed one, whatever frame colour is
  // picked, so that mark was never matched. getMainParentVariant gives the framed variant for the
  // colour picked right now (or the same variant when none is), so the lock follows exactly the
  // variant that was marked: A4 + black is locked, A4 + white is not.
  var framed = getMainParentVariant(main_variant);
  return !!(framed && framed.id != null && ids.indexOf(String(framed.id)) > -1);
}
// Free framing service (variant metafield custom.included_free_framing_service, via
// window.droolFreeFramingVariantIds). Same per-variant rule as isFramingServiceLocked: a mark on
// the unframed variant covers every colour at the size, a mark on a framed variant that colour only.
function isFramingServiceFree(main_variant) {
  if (!main_variant || main_variant.id == null) return false;
  var ids = (window.droolFreeFramingVariantIds || []).map(String);
  if (ids.indexOf(String(main_variant.id)) > -1) return true;
  var framed = getMainParentVariant(main_variant);
  return !!(framed && framed.id != null && ids.indexOf(String(framed.id)) > -1);
}
// ---------------------------------------------------------------------------
// Fulfilment partner properties (build spec 2026-09-11)
// ---------------------------------------------------------------------------
// Every value is a variant metafield, read in Liquid by snippets/drool-fulfilment-values.liquid
// and passed here as JSON {p: Prodigi SKU, a: Alfredssons SKU, f: custom.frame}. Nothing is
// derived from option names, so a new size or colour needs no code change.

// The print variant's codes, or null when the variant is not a print (gift card, frame page),
// in which case nothing is written at all.
function droolFulfilmentFor(variantId) {
  var hit = (window.drool_fulfilment || {})[String(variantId)];
  return hit ? { p: hit.p || '', a: hit.a || '', f: hit.f || '', pf: hit.pf || '' } : null;
}
// Codes rendered as a JSON attribute on an element, or null when the attribute is absent.
function droolReadFulfilment($el, attrName) {
  var raw = $el && $el.length ? $el.attr(attrName) : '';
  if (!raw) return null;
  try {
    var d = JSON.parse(raw);
    return { p: d.p || '', a: d.a || '', f: d.f || '', pf: d.pf || '' };
  } catch (e) {
    return null;
  }
}
// The framed Prodigi code for a print (e.g. GLOBAL-CFP-A4). It carries no colour, so it is read
// from the print's own framed variant at the same size, whichever colour that is. That is why no
// second metafield is needed on the print variant.
function droolFramedProdigiFor(printVariant) {
  var all = window.main_product_data || [];
  for (var i = 0; i < all.length; i++) {
    var v = all[i];
    if (printVariant && v.option1 === printVariant.option1 &&
        String(v.option2 || '').trim().toLowerCase().indexOf('framed') === 0) {
      var fd = droolFulfilmentFor(v.id);
      if (fd && fd.p) return fd.p;
    }
  }
  return '';
}
// A skipped row. IGNORE is always written, never omitted: partners read an absent property as
// "use the variant metafield", so a bare frame row would ship as a standalone frame.
function droolIgnoreProps() {
  return { _prodigi_sku: 'IGNORE', _alf_sku: 'IGNORE', _row_type: 'component' };
}
// _row_type (partner read rules, 2026-09-23): what the row IS, so a partner that sees every row of
// a mixed order can tell which are theirs. Separate from IGNORE, which says what to do with it.
//   print            an unframed print, paper or canvas
//   framed_print     a print assembled into its frame (framed code + _frame on the row)
//   standalone_frame a frame supplied on its own
//   component        part of another row: the frame and service under an assembled print
function droolWithRowType(props, type) {
  if (!props) return props;
  props._row_type = type;
  return props;
}
// A standalone frame row (print + frame, no framing service). The client confirmed Prodigi does
// not make standalone frames, and routing keeps them out of Prodigi orders, so Prodigi gets an
// explicit IGNORE, or the frame variant's own Prodigi code if it ever holds one. Only the
// Alfredssons code is required, so a gap there is still flagged.
function droolStandaloneFrameProps(fd) {
  var props = { _prodigi_sku: (fd && fd.p) || 'IGNORE', _row_type: 'standalone_frame' };
  return $.extend(props, droolRowProps({ _alf_sku: fd ? fd.a : '' }, ['_alf_sku']));
}
// Report a failed cart write. Uses window.droolReportError (snippets/drool-error-reporting.liquid)
// when it is loaded, otherwise the console. Never throws.
function droolReportCartFailure(context, failure) {
  var detail = 'unknown';
  try {
    if (typeof failure === 'string') {
      detail = failure;
    } else if (failure) {
      var body = failure.responseJSON || {};
      detail = body.description || body.message || failure.statusText || String(failure.status || 'unknown');
    }
  } catch (err) {}
  if (typeof window.droolReportError === 'function') {
    window.droolReportError(context, detail);
  } else if (window.console && console.error) {
    console.error('[drool] ' + context, detail);
  }
}
// Properties for one row. A required value that came back empty is named in _fulfilment_check, so
// a missing or misnamed metafield shows up on the order itself, still hidden from the customer.
function droolRowProps(values, required) {
  var props = {};
  var missing = [];
  required.forEach(function (key) {
    if (values[key]) { props[key] = values[key]; } else { missing.push(key); }
  });
  if (missing.length) props._fulfilment_check = 'missing:' + missing.join(',');
  return props;
}
// Writes the print row (items[0]) into its hidden inputs. An empty value leaves the input disabled,
// so that property is not sent at all.
// First paint only. Because updateVariants() is not run on load (see the ready block at the end
// of this file), a product with no child frames — a canvas, a non-A-ratio print — had its four
// fulfilment inputs still disabled until the shopper changed something, and an immediate add to
// cart sent the print with no partner codes. Write the current variant's own codes now; the first
// change hands over to updateVariants(). Does nothing when the inputs are absent or already set.
function droolPrimeFulfilmentInputs() {
  var $sku = $('.mrk-fullfilment-sku');
  if (!$sku.length || $sku.prop('disabled') === false) return;
  var main_variant = {};
  try { main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}'); } catch (e) { main_variant = {}; }
  if (!main_variant || main_variant.id == null) return;
  var fd = droolFulfilmentFor(main_variant.id);
  if (!fd) return;
  var framed = String(main_variant.option2 || '').trim().toLowerCase().indexOf('framed') === 0;
  var props = framed
    ? droolWithRowType(droolRowProps({ _prodigi_sku: fd.p, _alf_sku: fd.a, _frame: fd.f }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print')
    : droolWithRowType(droolRowProps({ _prodigi_sku: fd.p, _alf_sku: fd.a }, ['_prodigi_sku', '_alf_sku']), 'print');
  droolWriteRowInputs(props);
}
function droolWriteRowInputs(props) {
  var inputs = {
    _prodigi_sku: '.mrk-fullfilment-sku',
    _alf_sku: '.wd-alf-sku',
    _frame: '.wd-frame-value',
    _fulfilment_check: '.wd-fulfilment-check',
    _row_type: '.wd-row-type'
  };
  Object.keys(inputs).forEach(function (key) {
    var val = props ? props[key] : '';
    var $input = $(inputs[key]);
    if (val) { $input.val(val).prop('disabled', false); } else { $input.val('').prop('disabled', true); }
  });
}
// Framing system selection - parent-only ("framed_print_only") vs parent+child ("child_frame").
// Resolution priority: variant metafield override -> product size list -> derived from child_frames.
function getFramingMode(main_variant) {
  if (!main_variant || main_variant.id == null) return 'Child frame';
  // Item 16 (architecture checklist): a paper print never sells its built-in framed variants on
  // the site once the theme setting is on. Every size is child-frame mode; a size with no child
  // frame yet is unframed-only. Overrides below (metafield lists, frame stock) are not consulted.
  if (window.drool_child_frames_only) return 'Child frame';

  var vid = String(main_variant.id);
  var fpoVariantIds = (window.framed_print_only_variant_ids || []).map(String);
  var cfVariantIds = (window.child_frame_variant_ids || []).map(String);
  if (fpoVariantIds.indexOf(vid) > -1) return 'Framed print only';
  if (cfVariantIds.indexOf(vid) > -1) return 'Child frame';
  // If the merchant has explicitly marked some variants as "Child frame",
  // treat the marked list as an allowlist - any variant outside it is parent-only.
  if (cfVariantIds.length > 0) return 'Framed print only';

  var size = String(main_variant.option1 || '').trim().toLowerCase();
  var norm = function (s) { return String(s).trim().toLowerCase(); };
  var fpoSizes = (window.framed_print_only_sizes || []).map(norm);
  var childSizes = (window.child_frame_sizes || []).map(norm);

  if (fpoSizes.indexOf(size) > -1) return 'Framed print only';
  // Implicit fallback: if the product declares which sizes have child frames
  // and the selected size is not in that set, treat it as framed-print-only.
  if (childSizes.length && childSizes.indexOf(size) === -1) return 'Framed print only';
  // Derived fallback: the frame product itself knows which sizes it can frame.
  // Its hidden Size fieldset (frame-variant-picker, present in the initial
  // render AND every ?view=frame refetch) carries data-option-available per
  // size. When the selected size's frame option value is unavailable (e.g. A0:
  // all child frames out of stock), variant-main-picker-frame.liquid skips
  // every colour swatch server-side and the child-frame picker renders empty -
  // the size is only sellable through the artwork's own "Framed ..." variants,
  // so it must be FPO. Matched by exact value (size values contain quotes,
  // e.g. 33x47" (A0), so an attribute selector can't be used); sizes missing
  // from the frame product keep the legacy behaviour below.
  var $frameSize = $('frame-variant-picker input[type=radio]').filter(function () {
    return norm($(this).val()) === size;
  }).first();
  if ($frameSize.length && $frameSize.attr('data-option-available') === 'false') {
    return 'Framed print only';
  }
  return 'Child frame';
}
// Item 16: does a paper print have NO child frame at the selected size? Decided by the frame
// product alone: it has no such size, or every frame at that size is out of stock. The print's own
// child_frames list is not consulted (item 16 ignores it, see getFramingMode), so a new frame size
// works for every print the moment the frame product carries it.
// When the frame product has no such size the frame picker is not refetched
// (mrkBeforeVariantChanged returns early) and still shows the PREVIOUS size's frames: without
// this, a 9x12 print took a 6x8 frame. False whenever the setting is off: no change for live.
function droolNoChildFrameAtSize(main_variant) {
  if (!window.drool_child_frames_only || !main_variant || main_variant.id == null) return false;
  if (!$('frame-variant-picker').length) return false;
  var norm = function (s) { return String(s).trim().toLowerCase(); };
  var size = norm(main_variant.option1 || '');
  var $frameSize = $('frame-variant-picker input[type=radio]').filter(function () {
    return norm($(this).val()) === size;
  }).first();
  return !$frameSize.length || $frameSize.attr('data-option-available') === 'false';
}
function updateVariants() {
  var main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
  // No canonical #mrk-main-variant-data in the DOM (e.g. every picker arm hidden
  // mid-transition): acting on {} would blank items[0][id] (jQuery .val(undefined)
  // sets '') and overwrite the real prices with formatMoney(NaN) → £0. Keep the
  // last good form/price state and let the next run with real data resync.
  if (main_variant == null || main_variant.id == null) return;
  var child_frame = $('[name="framing-service"]').is(':checked'),
    fulfillment_function = $('.mrk-fullfilment-sku').length,
    free_framing_service_data = JSON.parse($('#mrk-framing-service-data').text() || '{}'),
    free_framing_service = free_framing_service_data.free_framing_service || window.free_framing_service,
    frame = $('.mrk-frame-switcher input:checked'),
    frame_price = $(frame).data('variantPrice'),
    frame_compare_price = $(frame).data('variantComparePrice'),
    framing_service = !$('[name="framing-service"]').is(':checked'),
    framing_service_variant = $('[name="framing-service"]').val(),
    framing_service_compare_price = $('[name="framing-service"]').data('comparePrice'),
    framing_service_price = $('[name="framing-service"]').data('price'),
    frame_variant = $(frame).data('variantId'),
    frame_id = $('media-gallery .mrk-active-gallery-frame').data('frameId'),
    is_unframed = frame_variant ? false : true,
    // Cart STRUCTURE (theme setting wd_three_line_cart), separate from the properties switch
    // (fulfillment_function). Off = today's shape: framed variant + service. On = print + child
    // frame + service. Properties are written onto whichever shape is active.
    three_line = !!window.drool_three_line_cart,
    // Fulfilment properties for the print row (items[0]); child rows carry theirs on `variants`.
    // Stays null for anything that is not a print, so those rows write nothing and the partners
    // fall back to the variant metafields.
    print_props = null,
    variants = [],
    prices = [];
  // Item 16: a size with no child frame sells unframed only. The frame swatches are hidden and the
  // picker is put back on Unframed without a change event (a trigger would re-enter this function).
  if (window.drool_child_frames_only) {
    var wd_no_frame = droolNoChildFrameAtSize(main_variant);
    var $wdFramedSwatches = $('.mrk-frame-switcher input[frame-color]').not('[frame-color="unframed"]').closest('label');
    if (wd_no_frame) {
      $wdFramedSwatches.addClass('wd-no-frame-size').hide();
    } else {
      $wdFramedSwatches.filter('.wd-no-frame-size').removeClass('wd-no-frame-size').css('display', '');
    }
    if (wd_no_frame && !is_unframed) {
      $('.mrk-frame-switcher input[frame-color="unframed"]').first().prop('checked', true);
      frame = $('.mrk-frame-switcher input:checked');
      frame_price = $(frame).data('variantPrice');
      frame_compare_price = $(frame).data('variantComparePrice');
      frame_variant = undefined;
      is_unframed = true;
    }
  }
  // Locked size: force the framing service ON. The checkbox is un-ticked without a change
  // event (a trigger here would re-enter updateVariants) and hidden further down.
  var framing_locked = isFramingServiceLocked(main_variant);
  if (framing_locked) {
    $('[name="framing-service"]').prop('checked', false);
    child_frame = false;
    framing_service = true;
  }
  // Free framing at this size + colour: the print ships assembled with no service charge. Forced on
  // like the lock, so a "remove" ticked on another colour cannot turn it into an unassembled frame;
  // the service line itself is skipped below by free_framing_service.
  if (isFramingServiceFree(main_variant)) {
    free_framing_service = true;
    $('[name="framing-service"]').prop('checked', false);
    child_frame = false;
    framing_service = true;
  }
  var framing_mode = getFramingMode(main_variant);
  var force_fpo = framing_mode === 'Framed print only';
  // Products with NO framing metafields at all (typically non-A-ratio artworks:
  // no child_frames, no framed_print_only_sizes, no framing_sale_mode) fall
  // through getFramingMode to 'Child frame' - yet their framed variants ARE
  // framed-print-only: option2 is "Framed black"/"Framed natural"/... with the
  // frame included in the variant price, and there is no frame-variant-picker
  // on the page. Same rule as the live theme: a selected option2 beginning
  // with "framed" forces FPO, so the framing-service / free-framing message
  // shows for these products too.
  if (!force_fpo && !window.drool_child_frames_only && String(main_variant.option2 || '').trim().toLowerCase().indexOf('framed') === 0) {
    force_fpo = true;
  }
  // "Child frame" mode is fully legacy: pricing, cart line, and the unframed-
  // parent vs. framed-parent decision are all driven by the framing-service
  // checkbox below. No force_cf override - keep the original child/parent
  // system intact for those variants.
  // On a mode FLIP the visible frame slider swaps (child picker <-> the main
  // picker's FPO swatches). The revealed one was display:none whenever overflow
  // was last measured - refreshSwatchOverflow skips hidden sliders - so its
  // .mrk-enable-controls (the arrows' CSS gate, mrk.css) was never applied and
  // the arrows stay hidden (e.g. size change into A0/FPO). Re-bind + re-measure
  // AFTER the class toggle, same order the bootstrap enforces on page load.
  var fpo_mode_flipped = $('body').hasClass('mrk-fpo-active') !== force_fpo;
  $('body').toggleClass('mrk-fpo-active', force_fpo);
  if (fpo_mode_flipped) {
    initSwatchSlider();
  }
  if (force_fpo) {
    // Framed-Print-Only: artwork variant already includes the frame.
    // No child frame item, no framing service line; submit only the parent variant.
    if (frame_id) {
      $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    } else {
      $('.mrk-frame-id').prop('disabled', true);
    }
    $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    // FPO framed variants already include the frame + framing in the price.
    // Mirror the cart rule (frame-framing-service.liquid): a framed option2
    // selected => show the "free framing" message; unframed selected => hide.
    // The included_free_framing_service metafield still forces it on when set.
    var fpo_framed_selected = String(main_variant.option2 || '').trim().toLowerCase().indexOf('framed') === 0;
    if (free_framing_service || fpo_framed_selected) {
      $('.free-framing-service:not(.bundle)').show();
    } else {
      $('.free-framing-service:not(.bundle)').hide();
    }
    // A variant with the frame built in, bought on this page. It is the only way canvas is framed,
    // and the only way framed-only art sizes are sold. One row, one item, so it carries that
    // variant's own codes (framed canvas: GLOBAL-FRA-CAN-A4, 8.3x11.7inch_A4_CAN, black). The
    // spec's "write nothing" rule covers orders from outside this page (third-party channels,
    // bundle builder, gallery wall), which never run this code.
    var fpo_data = droolFulfilmentFor(main_variant.id);
    if (fpo_data) {
      print_props = fpo_framed_selected
        ? droolWithRowType(droolRowProps({ _prodigi_sku: fpo_data.p, _alf_sku: fpo_data.a, _frame: fpo_data.f }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print')
        : droolWithRowType(droolRowProps({ _prodigi_sku: fpo_data.p, _alf_sku: fpo_data.a }, ['_prodigi_sku', '_alf_sku']), 'print');
    }
  } else if (!is_unframed) {
    // Fulfilment properties (build spec 2026-09-11). Partners match ONE code to ONE item to make.
    //  - print + frame + framing service = one item (scenario 2): the print row carries the print's
    //    FRAMED Prodigi code, its Alfredssons code and _frame; frame and service rows are IGNORE.
    //  - print + frame, service removed = two items (scenario 3): the print row carries its own
    //    codes and the frame row carries the frame variant's own codes.
    // Child rows carry theirs as `props` on the variants entries; they become hidden inputs below.
    var print_data = droolFulfilmentFor(main_variant.id);
    var frame_data = droolReadFulfilment(frame, 'data-wd-fulfilment');
    var frame_line = null;
    if (three_line || child_frame) {
      frame_line = { id: frame_variant, parent_id: main_variant.id };
      variants.push(frame_line);
      prices.push({ price: frame_price, compare_price: frame_compare_price });
      if (print_data) {
        print_props = droolWithRowType(droolRowProps({ _prodigi_sku: print_data.p, _alf_sku: print_data.a }, ['_prodigi_sku', '_alf_sku']), 'print');
        frame_line.props = droolStandaloneFrameProps(frame_data);
      }
    } else {
      var mrk_variant = getMainParentVariant(main_variant)
      main_variant = mrk_variant;
    }
    if (framing_service) {
      if (!free_framing_service) {
        var service_line = { id: framing_service_variant, parent_id: main_variant.id };
        if (print_data) service_line.props = droolIgnoreProps();
        variants.push(service_line);
        prices.push({ price: framing_service_price, compare_price: framing_service_compare_price });
      } else {
        // Free framing: the £0 framing service (framing-service-1) takes the paid one's place, so
        // the cart and checkout still list the service, as Free.
        var free_service_id = Number($('.free-framing-service:not(.bundle)').first().attr('data-wd-free-service-id')) || 0;
        if (free_service_id) {
          var free_service_line = { id: free_service_id, parent_id: main_variant.id };
          if (print_data) free_service_line.props = droolIgnoreProps();
          variants.push(free_service_line);
          prices.push({ price: 0, compare_price: 0 });
        }
      }
      if (print_data && frame_line) {
        // Three-line shape: the row is the UNFRAMED print, assembled by us.
        //  _prodigi_sku: the framed code. Read order: the unframed variant's own
        //    custom.prodigi_framed_sku ("pf", works for a size with no legacy framed variant),
        //    then the legacy framed sibling for the chosen colour, then any framed sibling.
        //  _frame: the child frame the customer picked (its custom.frame), then the legacy framed
        //    sibling's value while frame variants still have that metafield empty.
        // getMainParentVariant is only read here; main_variant is not reassigned.
        var framed_variant = getMainParentVariant(main_variant);
        var framed_data = framed_variant && framed_variant.id !== main_variant.id ? droolFulfilmentFor(framed_variant.id) : null;
        print_props = droolWithRowType(droolRowProps({
          _prodigi_sku: print_data.pf || (framed_data && framed_data.p) || droolFramedProdigiFor(main_variant),
          _alf_sku: print_data.a,
          _frame: (frame_data && frame_data.f) || (framed_data ? framed_data.f : '')
        }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print');
        frame_line.props = droolIgnoreProps();
      } else if (print_data) {
        // Today's shape: main_variant has been swapped to the print's own FRAMED variant above, so
        // the row IS the assembled item and carries that variant's own codes. _frame still prefers
        // the child frame the customer picked.
        var own_data = droolFulfilmentFor(main_variant.id) || {};
        print_props = droolWithRowType(droolRowProps({
          _prodigi_sku: own_data.p || print_data.pf || droolFramedProdigiFor(main_variant),
          _alf_sku: own_data.a || print_data.a,
          _frame: (frame_data && frame_data.f) || own_data.f || ''
        }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print');
      }
    }

    $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    $('.mrk-framing-service-wrapper:not(.bundle)').show();
    if (free_framing_service) {
      $('.mrk-framing-service-wrapper:not(.bundle)').hide();
      $('.free-framing-service:not(.bundle)').show();
    } else {
      $('.free-framing-service:not(.bundle)').hide();
      $('.mrk-framing-service-wrapper:not(.bundle)').show();
    }
    if (framing_locked) {
      $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    }
  } else {
    var mrk_variant = getMainParentVariant(main_variant)
    main_variant = mrk_variant;
    // Unframed print on its own (scenario 1): one item, the print variant's own codes, no _frame.
    // droolFulfilmentFor is null for anything that is not a print, which then writes nothing.
    var unframed_data = droolFulfilmentFor(main_variant.id);
    if (unframed_data) {
      print_props = droolWithRowType(droolRowProps({ _prodigi_sku: unframed_data.p, _alf_sku: unframed_data.a }, ['_prodigi_sku', '_alf_sku']), 'print');
    }
    $('.free-framing-service:not(.bundle)').hide();
    $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    $('.mrk-frame-id').prop('disabled', true);
  }
  // Locked and charged: the remove box is hidden above, so say the service is included and what it
  // costs. Free framing shows its own message instead.
  $('.wd-framing-locked-note:not(.bundle)').toggle(!force_fpo && !is_unframed && framing_locked && !free_framing_service);

  prices.push({ price: main_variant.price, compare_price: main_variant.compare_at_price || main_variant.price, wd_offer: true });

  updatePrices(prices);
  $('.mrk-product-form-wrapper [name="items[0][id]"]').val(main_variant.id);
  // Print row (items[0]) fulfilment inputs. print_props stays null for anything that is not a
  // print, which disables every input: nothing sent.
  droolWriteRowInputs(print_props);
  // Horizon's product-form disables the add-to-cart button on every variant
  // change and only re-enables it via its own section fetch. Inside the
  // quick-add modal that re-enable is unreliable, leaving the button stuck
  // disabled after a size change. Since we've just resolved a purchasable
  // variant here, restore the button to its normal (enabled) state. No-op on
  // the PDP (already enabled); unavailable variants are left disabled.
  if (main_variant && main_variant.available !== false) {
    $('.mrk-product-form-wrapper [ref="addToCartButton"]').prop('disabled', false).removeAttr('disabled');
  }
  var inputs = '';
  variants.forEach(function (v, i) {
    var idx = i + 1;
    inputs += '<input name="items[' + idx + '][id]" type="hidden" value="' + (v.id || '') + '" />\n';
    inputs += '<input name="items[' + idx + '][parent_id]" type="hidden" value="' + (v.parent_id || '') + '" />\n';
  });

  $('.mrk-hidden-inputs').empty().append(inputs);
  // Child row fulfilment properties, only when the buy-buttons block renders the fulfilment inputs
  // (the same switch as the print row). Built with jQuery attributes, not concatenated HTML (R1).
  if (fulfillment_function) {
    variants.forEach(function (v, i) {
      if (!v.props) return;
      Object.keys(v.props).forEach(function (key) {
        $('<input>', { type: 'hidden', name: 'items[' + (i + 1) + '][properties[' + key + ']]', value: v.props[key] })
          .appendTo('.mrk-hidden-inputs');
      });
    });
  }
  // Today's shape needs _main_variant on a print + loose frame row so the drawer can swap it to
  // the assembled framed variant when the service is added later. Tied to the structure switch,
  // not to the properties switch.
  if (!force_fpo && !three_line && child_frame) {
    $('.mrk-hidden-inputs').append('<input name="items[0][properties[_main_variant]]" type="hidden" value="' + (getMainParentVariant(main_variant).id || '') + '" />')
  }
  var frame_color_value = force_fpo ? (main_variant.option2 || '') : $(frame).val();
  $('.mrk-frame-color').val(frame_color_value).prop('disabled', false);
  $('.mrk-bundle-id').val(Math.floor((Date.now() % 100000) * Math.random())).prop('disabled', false);
}
function alreadyCheckedFrame() {
  // window.selected_frame is ONLY ever assigned by the mrkBeforeVariantChanged
  // handler, and that handler early-returns for a size the frame product does
  // not carry (an FPO size). So on a product whose first size is framed-print-
  // only - or before any child-frame size has been picked - it is still
  // `undefined` here, and `[frame-color="undefined"]` matches nothing.
  var target = window.selected_frame;
  var hasTarget = target != null && String(target) !== '';
  if (hasTarget) {
    // Same rule as the carry-over: a remembered colour is only re-asserted onto a
    // swatch this size can actually sell. An unavailable one is left unchecked, so
    // the picker falls through to Unframed below.
    $(`.mrk-frame-switcher input[frame-color="${target}"]`).not('[data-option-available="false"]').prop('checked', true).trigger('change');
  }
  setTimeout(function () {
    var $group = $('.mrk-frame-switcher input[frame-color]');
    if (!$group.length) return;
    var $target = hasTarget ? $group.filter(`[frame-color="${target}"]`).not('[data-option-available="false"]') : $();
    if ($target.length) {
      // Re-assert the remembered colour if the re-render didn't keep it.
      if (!$target.first().is(':checked')) {
        $target.first().prop('checked', true).trigger('change');
      }
      return;
    }
    // No remembered colour, or it isn't offered for this size. Leave whatever
    // is already selected alone - the server render checks "Unframed", so this
    // is normally the shopper's own state. Only an EMPTY group needs a default,
    // and that default is the FIRST swatch ("Unframed"), never the last.
    //
    // The old code checked the whole group here. They are one radio group, so
    // "check them all" left the LAST swatch (Oak/Natural) selected: on a
    // product with a framed-print-only size in the middle of its size list,
    // stepping 6x8 -> 9x12 -> 12x16 silently switched the shopper from
    // Unframed to Oak and turned on the framing service. Stepping 6x8 -> 12x16
    // directly did not, because that path sets window.selected_frame.
    if (!$group.filter(':checked').length) {
      $group.first().prop('checked', true).trigger('change');
      return;
    }
    // Nothing needed re-selecting. The blanket trigger('change') above used to
    // be what re-ran updateVariants() after a size change - that is what sets
    // the framed-print-only body class, the prices and the hidden cart inputs.
    // Now that we no longer fire a bogus change on the whole group, drive it
    // explicitly so a size change with an unchanged frame still resyncs.
    if (typeof updateProductPageFrame === 'function') updateProductPageFrame();
  }, 100)
} 
function initStickyAddToCart() {
  var $FormWrapper = $('.product-details product-form-component:not(.mrk-bundle-form)');
  if ($FormWrapper.length) {
    var lastScrollTop = 0;
    var originalHeight = $FormWrapper.outerHeight();
    $FormWrapper.css('--height', originalHeight + 'px');
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function updateStickyAddToCart() {
      // Hidden form (e.g. bundle pack mode hides the native buy-box): offset() reads 0,
      // so any scroll past 100px would pin the fixed class to the hidden form — and it
      // stayed applied when switching back to single view, breaking the CTA position.
      // Not visible → strip the sticky state and bail.
      if (!$FormWrapper.is(':visible')) {
        $FormWrapper.removeClass('mrk-fixed-add-to-cart-form');
        $FormWrapper.css('min-height', '');
        return;
      }
      // The wrapper keeps its box while pinned (min-height: var(--height); only the
      // inner form goes fixed), so offset() still reports the buy box's real place in
      // the page. Re-read every pass: the gallery collapses from stacked slides to a
      // carousel once the slideshow initialises, moving this by over a thousand pixels.
      var naturalTop = $FormWrapper.offset().top;
      var originalOffsetTop = naturalTop + 100;
      var scrollTop = $(window).scrollTop();
      // The ONLY behaviour change: on mobile, also pin while the buy box is still below
      // the fold, so the CTA is on screen when you land on the page. Everything else is
      // untouched - once you scroll down to its real position it releases and sits inline,
      // and once that position scrolls off the top the original rule pins it again.
      // Height falls back to 0 rather than gating the whole test, so an unmeasured
      // --height can never leave the button off screen at landing.
      var knownHeight = originalHeight > 0 ? originalHeight : 0;
      var belowFold = mobileQuery.matches &&
        (naturalTop + knownHeight - scrollTop) > window.innerHeight;
      // Always add class when top bar has scrolled up past original position
      if (scrollTop > originalOffsetTop || belowFold) {
        if (!$FormWrapper.hasClass('mrk-fixed-add-to-cart-form')) {
          $FormWrapper.addClass('mrk-fixed-add-to-cart-form');
        }
      } else {
        $FormWrapper.removeClass('mrk-fixed-add-to-cart-form');
        $FormWrapper.css('min-height', '');
      }

      // If user scrolls up while fixed, set min-height
      if (scrollTop < lastScrollTop && scrollTop > originalOffsetTop) {
        $FormWrapper.css('min-height', originalHeight + 'px');
      }

      lastScrollTop = scrollTop;
    }

    $(window).on('scroll', updateStickyAddToCart);
    $(window).on('resize', updateStickyAddToCart);
    // Initial pass is what puts the bar on screen when the page loads - the handler
    // used to be bound to 'scroll' only, so the class could never exist on landing.
    // The deferred passes re-check after the gallery and lazy images settle, the same
    // pattern initSwatchSlider uses at 350ms / 1200ms.
    updateStickyAddToCart();
    setTimeout(updateStickyAddToCart, 350);
    setTimeout(updateStickyAddToCart, 1200);
  }
}
var SWATCH_TOLERANCE = 2; // px, absorbs sub-pixel rounding

// Decide whether each slider NEEDS arrows at all (does its content overflow?).
// This is the only place .mrk-enable-controls (the container's CSS gate) is
// toggled - and it runs on init / resize / image-load, NOT on scroll - so a
// transient mis-measurement while scrolling can never collapse the arrows.
// Hidden sliders (display:none) are skipped so their state isn't clobbered.
function refreshSwatchOverflow() {
  $('.mrk-swatches-slider-wrapper').each(function () {
    var el = $(this).find('.mrk-swatches-wrapper')[0];
    if (!el || (el.offsetParent === null && el.getClientRects().length === 0)) return;
    var overflows = (el.scrollWidth - el.clientWidth) > SWATCH_TOLERANCE;
    $(this).toggleClass('mrk-enable-controls', overflows);
  });
  updateSwatchArrows();
}

// Show/hide the individual prev/next buttons by scroll position. Only touches
// sliders already marked scrollable (.mrk-enable-controls) and never changes
// that class - so scrolling can't make the whole arrow set disappear.
function updateSwatchArrows() {
  $('.mrk-swatches-slider-wrapper.mrk-enable-controls').each(function () {
    var $slider = $(this);
    var el = $slider.find('.mrk-swatches-wrapper')[0];
    if (!el) return;

    var maxScroll = el.scrollWidth - el.clientWidth;
    var scrollLeft = el.scrollLeft;

    $slider.find('.slideshow-control[ref="previous"]').toggle(scrollLeft > SWATCH_TOLERANCE);
    $slider.find('.slideshow-control[ref="next"]').toggle(scrollLeft < maxScroll - SWATCH_TOLERANCE);
  });
}

function initSwatchSlider() {
  var $wrappers = $('.mrk-swatches-wrapper');
  if ($wrappers.length === 0) return;

  // scroll doesn't bubble, so bind it directly on each wrapper (re-applied on
  // every render). Scroll only moves the prev/next buttons, never the container.
  $wrappers.off('scroll.swatchSlider').on('scroll.swatchSlider', updateSwatchArrows);
  // Overflow can change on resize and, crucially, when the lazy-loaded swatch
  // images finish loading (their width is what makes the row overflow) - both
  // recompute whether arrows are needed.
  $(window).off('resize.swatchSlider').on('resize.swatchSlider', refreshSwatchOverflow);
  $wrappers.find('img').off('load.swatchSlider').on('load.swatchSlider', refreshSwatchOverflow);

  // Initial pass + deferred passes: 350ms for the modal open animation, 1200ms
  // as a backstop for slow image loads so the arrows aren't left hidden.
  refreshSwatchOverflow();
  setTimeout(refreshSwatchOverflow, 350);
  setTimeout(refreshSwatchOverflow, 1200);
}
function updateProductPageFrame() {
  if ($('variant-picker').length == 0) {
    return
  }
  // In FPO mode the frame-variant-picker is hidden and its :checked:eq(1) is
  // stale (typically the last/default frame, e.g. oak). Drive the gallery
  // image from the main variant-picker's frame swatch instead. Detect the
  // mode from the current main variant so we pick up size-driven transitions
  // even before body class catches up.
  var current_main_variant = {};
  try { current_main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}'); } catch (e) {}
  var is_fpo_now = typeof getFramingMode === 'function' && getFramingMode(current_main_variant) === 'Framed print only';
  var frameName;
  if (is_fpo_now) {
    var $vpFrame = $('variant-picker input:checked').filter(function () {
      var fc = ($(this).attr('frame-color') || '').trim();
      return fc.length > 0;
    }).last();
    frameName = ($vpFrame.attr('frame-color') || '').toLowerCase();
  } else {
    var selectedFrame = $('frame-variant-picker input:checked:eq(1)');
    frameName = $(selectedFrame).val()?.toLowerCase();
  }
  // Fallback (live-theme parity): products without a frame-variant-picker and
  // without frame-color attributes resolve nothing above, but their main
  // variant's option2 ("Framed black") names the frame - derive it from there
  // so the gallery frame overlay and _frame_id follow the selection.
  if (!frameName || frameName === 'unframed') {
    try {
      var fallback_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
      var fallback_o2 = String(fallback_variant.option2 || '').trim().toLowerCase();
      if (fallback_o2.indexOf('framed') === 0) {
        frameName = fallback_o2.replace(/^framed[\s-]*/, '').replace(/\s+/g, '-');
      }
    } catch (e) {}
  }
  // Default-preview fallback: with an unframed default (show_default_black_variant)
  // and no real shopper frame pick yet, resolve to the default preview frame
  // instead of stripping the overlay. Every reassert path (both fetch callbacks
  // on a size change, mrkVariantChanged, drool-frame-default.js) funnels through
  // here, so resolving "unframed" would end first loads with no frame at all.
  if ((!frameName || frameName === 'unframed') && window.show_default_black_variant && !window.__mrkFrameTouched) {
    frameName = String(window.mrk_default_preview_frame || 'black');
  }
  $('media-gallery .mrk-featured-product-frame-wrapper .mrk-frame-image-item').removeClass('mrk-active-gallery-frame').hide();
  $(`media-gallery .mrk-frame-image-item[color="${frameName}"]`).addClass('mrk-active-gallery-frame').show();
  // Natural and Oak are the same frame; the popup tabs always answer to "oak" (frame-popup.liquid).
  $(`.mrk-tab-trigger[data-content="${/(^|-)(natural|oak)(-|$)/.test(String(frameName)) ? 'oak' : frameName}"]`).click();
  updateVariants();
}
function mrkApplyGiftAdjustments() {
  var el = document.getElementById('mrk-gift-json');
  if (!el) return;

  var items;
  try { items = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
  if (!Array.isArray(items) || !items.length) return;

  // Only process items where new_qty is explicitly 0 (removal of free gifts)
  var itemsToRemove = items.filter(function(it) {
    return parseInt(it.new_qty, 10) === 0;
  });

  if (!itemsToRemove.length) return;

  // Build updates object with ONLY the gift item keys set to 0
  var updates = {};
  itemsToRemove.forEach(function(it) {
    var key = String(it.key || '');
    if (!key) return;
    updates[key] = 0;
  });

  if (!Object.keys(updates).length) return;

  // Get section IDs for cart refresh
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map(el => el.dataset.sectionId)
    .filter(Boolean);

  // Use /cart/update.js with specific keys — this only touches what you pass in
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: { updates: updates, sections: sectionIds }
  }).then(function(response) {
    if (typeof window.manualCartRefresh === 'function') {
      window.manualCartRefresh(response);
    }
  });
}
$(document).on('mrkBeforeVariantChanged', function (e) {
  var selectedOption = e.detail;
  $('.mrk-size-selector-wrapper details').prop('open', false);
  $('frame-variant-picker input').each(function () {
    if ($(this).val() === selectedOption) {
      $(this).prop('checked', true);
    }
  });
  if ($(`frame-variant-picker input[value='${selectedOption}']`).length == 0) {
    return;
  }
  window.selected_frame = $('.mrk-frame-switcher input:checked').attr('frame-color');
  var url = buildRequestUrl();
  // Stamp this request so only the NEWEST response is applied. Change size twice in
  // quick succession and both ?view=frame requests stay in flight - nothing aborted
  // or sequenced them - so each one replaced the picker's 29KB of markup when it
  // happened to land. That is two full rebuilds of the frame row, i.e. the double
  // blink, and if the older response arrived last the picker was left showing the
  // PREVIOUS size's frame prices. The stamp lives on the element itself (the swap
  // below replaces its children, never the node), so this adds no new global.
  var $framePicker = $('frame-variant-picker');
  var fetchSeq = (Number($framePicker.data('mrkFrameSeq')) || 0) + 1;
  $framePicker.data('mrkFrameSeq', fetchSeq);
  $.get(url, function (response) {
    // Superseded by a later size change - drop it rather than repaint with stale markup.
    if (Number($('frame-variant-picker').data('mrkFrameSeq')) !== fetchSeq) return;
    // Locate the picker in the response. $(response).find(...) only searches DESCENDANTS, so it
    // misses the picker whenever it comes back as a top-level node - the ?view=frame reply is a
    // full page on the PDP but a section fragment in the quick-add modal, and the two nest
    // differently. When it missed, `variantPickerHtml` was undefined and the .html() below BLANKED
    // the picker: its Black/White/Oak swatches vanished and only the print's own "Unframed" option
    // (which lives in a separate <variant-picker>) was left. $.parseHTML is used rather than
    // $('<div>').html() so scripts in the response are never executed - same as before.
    var $parsed = $($.parseHTML(response));
    var $picker = $parsed.filter('frame-variant-picker').add($parsed.find('frame-variant-picker'));
    var variantPickerHtml = $picker.first().html();
    // Only replace when we actually have markup. A failed/mismatched response now leaves the
    // current swatches in place instead of wiping them.
    if (variantPickerHtml) {
      $('frame-variant-picker').html(variantPickerHtml);
    }
    RemoveUnavailableVariants();
    initSwatchSlider();
    alreadyCheckedFrame();
  });
  if (window.selected_frame) {
    // Natural and Oak are the same frame; the popup tabs always answer to "oak" (frame-popup.liquid).
    $(`.mrk-tab-trigger[data-content="${/(^|-)(natural|oak)(-|$)/.test(String(window.selected_frame)) ? 'oak' : window.selected_frame}"]`).click();
  } else {
    $(`.mrk-tab-trigger`).first().click();
  }
});
;(function () {
  // Module-scoped previous-framing-mode tracker, closed over by the handler.
  // Seeded by the bootstrap below from the initial main variant.
  var mrkPrevFramingMode = null;
  window.__mrkSeedPrevFramingMode = function (mode) {
    if (mrkPrevFramingMode === null && mode) mrkPrevFramingMode = mode;
  };

  // Last colour the customer picked in the child-frame switcher. option2 cannot be
  // used for this: on a standalone size the print itself stays "Unframed" and the
  // colour lives only in the switcher, which is rebuilt (and reset) on a size change.
  var mrkLastFrameColor = null;
  // True only while the frame below was selected BY US (not by the customer), so the
  // carry-over can be undone on the way back without touching a deliberate choice.
  var mrkAutoCarriedFrame = false;
  $(document).on('change', '.mrk-frame-switcher input', function () {
    var c = String($(this).attr('frame-color') || '').trim().toLowerCase();
    if (c && c !== 'unframed') mrkLastFrameColor = c;
  });

  $(document).on('mrkVariantChanged', function (e) {
    // Snap to Unframed ONLY on a real FPO -> Child-frame transition AND only
    // for products that use the child-frame system (frame-variant-picker is
    // rendered). Pure CF products would otherwise snap on every change
    // (cascades to oak), and "normal" products with mixed framing_sale_mode
    // metafields would snap any non-FPO pick back to Unframed.
    var newVariant = (e && e.detail) || {};
    var newMode = (newVariant && newVariant.option1 != null && typeof getFramingMode === 'function')
      ? getFramingMode(newVariant)
      : null;
    var prevMode = mrkPrevFramingMode;
    // Update tracker BEFORE any early return so the snap's re-entrant
    // mrkVariantChanged sees prevMode === 'Child frame' and exits.
    if (newMode) mrkPrevFramingMode = newMode;

    if (newMode === 'Child frame' && prevMode === 'Framed print only' && $('frame-variant-picker').length > 0) {
      var unframedValue = String(window.mrk_unframed_value || 'Unframed').trim().toLowerCase();
      var currentOption2 = String(newVariant.option2 || '').trim().toLowerCase();
      if (currentOption2 && currentOption2 !== unframedValue) {
        var $unframedSwatch = $('variant-picker .variant-option--swatches input').filter(function () {
          return String($(this).val() || '').trim().toLowerCase() === unframedValue;
        }).first();
        if ($unframedSwatch.length && !$unframedSwatch.is(':checked')) {
          $unframedSwatch[0].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    // Mirror of the snap above, for the opposite move: Child frame -> Framed print
    // only, i.e. leaving a size that HAS a standalone frame for one that does not.
    // The customer's colour lives in the child-frame switcher, not in option2, and
    // that switcher is rebuilt for the new size and comes back on Unframed. The page
    // is then left with no frame selected anywhere, so neither the removable framing
    // service nor the "Framing Service - FREE" copy shows until a reload. Carry the
    // colour onto the main picker's matching "Framed <colour>" swatch - the same
    // state a reload produces. mrkPrevFramingMode was already updated above, so the
    // re-entrant mrkVariantChanged sees prevMode 'Framed print only' and stops here.
    if (newMode === 'Framed print only' && prevMode === 'Child frame'
        && mrkLastFrameColor && $('frame-variant-picker').length > 0) {
      var wantColor = mrkLastFrameColor;
      // natural and oak are the same frame; same synonym rule bundle-builder.js uses.
      var oakish = /oak|natural|wood|pine/;
      var $framedSwatch = $('variant-picker .variant-option--swatches input').filter(function () {
        var val = String($(this).val() || '').trim().toLowerCase();
        if (val.indexOf('framed') !== 0) return false;
        // Rule: keep the shopper's frame across a size change, EXCEPT when the new
        // size cannot sell it. Those are exactly the swatches rendered struck through
        // and unclickable (.wd-frames-unavailable / data-option-available="false").
        // Carrying a colour onto one leaves the buy button stuck on "unavailable"
        // while the child picker still reads Unframed. Skipping it here means no
        // carry-over happens and the print stays Unframed, which every size can sell.
        if (String($(this).attr('data-option-available') || '').trim().toLowerCase() === 'false') return false;
        var word = val.replace(/^framed[\s-]*/, '');
        return oakish.test(wantColor) ? oakish.test(word) : word === wantColor;
      }).first();
      if ($framedSwatch.length && !$framedSwatch.is(':checked')) {
        mrkAutoCarriedFrame = true;
        $framedSwatch[0].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    // Undo that carry-over when the customer moves to a size that DOES have a
    // standalone frame. On those sizes the print's own "Framed ..." variants are
    // marked framed-print-only, so the frame we carried in would keep the page on
    // the FREE copy instead of offering the removable framing service. Only a frame
    // WE selected is undone; a colour the customer picked themselves is ALSO undone,
    // because on a child-frame size the main picker's "Framed ..." swatches are
    // hidden by CSS - the only ways to arrive on one are this carry-over or a
    // direct ?variant= link, and in both cases the size must offer its removable
    // framing service rather than the FREE copy. The colour itself is never lost:
    // it moves into the child picker below.
    if ($('frame-variant-picker').length > 0) {
      var newSize = String(newVariant.option1 || '').trim().toLowerCase();
      var standaloneSizes = (window.child_frame_sizes || []).map(function (x) {
        return String(x).trim().toLowerCase();
      });
      var unframedVal = String(window.mrk_unframed_value || 'Unframed').trim().toLowerCase();
      var curO2 = String(newVariant.option2 || '').trim().toLowerCase();
      if (standaloneSizes.indexOf(newSize) > -1 && curO2 && curO2 !== unframedVal) {
        // Read the colour off the main picker's checked swatch: its frame-color is
        // the canonical token the child swatches use too ("Framed natural" over
        // there is frame-color="oak" over here), so a frame the shopper picked
        // themselves resolves just as well as one we carried in. mrkLastFrameColor
        // is only a fallback - it is set by child-picker changes, so it is empty
        // when the shopper never touched the child picker.
        var $leavingSwatch = $('variant-picker .variant-option--swatches input:checked').filter(function () {
          return String($(this).attr('frame-color') || '').trim() !== '';
        }).last();
        var carryBackColor = String($leavingSwatch.attr('frame-color') || '').trim().toLowerCase()
          || mrkLastFrameColor;
        var $backToUnframed = $('variant-picker .variant-option--swatches input').filter(function () {
          return String($(this).val() || '').trim().toLowerCase() === unframedVal;
        }).first();
        if ($backToUnframed.length && !$backToUnframed.is(':checked')) {
          mrkAutoCarriedFrame = false;
          $backToUnframed[0].dispatchEvent(new Event('change', { bubbles: true }));
          // Snapping the parent back to Unframed is only half the job: the colour
          // has to reappear in the CHILD picker too. Without it nothing is framed,
          // so updateVariants() hides the removable framing service AND the FREE
          // copy, and the size looks like it offers no framing at all - this is
          // why "Framing Service - FREE" never became "Remove Framing Service"
          // when the shopper stepped back onto a child-frame size.
          // The dispatch above has already run mrkBeforeVariantChanged, which
          // reset the child switcher and set window.selected_frame to 'unframed',
          // so this has to be assigned AFTER it. alreadyCheckedFrame() then
          // re-asserts the colour on the re-render this dispatch kicked off.
          if (carryBackColor && carryBackColor !== unframedVal) {
            window.selected_frame = carryBackColor;
          }
          return;
        }
      }
    }

    // Safety net for the same rule, covering the routes that do NOT go through the
    // carry-over above: a ?variant= link straight onto an unavailable combination, or
    // the server keeping option2 across a size change. If the frame swatch that ended
    // up checked is one this size cannot sell, snap to Unframed instead of leaving the
    // buy button on "unavailable" while the child picker still reads Unframed.
    // The dispatch re-enters this handler, where the checked swatch is then the
    // available Unframed one, so this cannot fire twice.
    var $deadFrame = $('variant-picker .variant-option--swatches input:checked').filter(function () {
      // Size radios also sit in a swatch fieldset, so identify a frame the way the
      // rest of this file does: an option2 value beginning with "framed".
      return String($(this).val() || '').trim().toLowerCase().indexOf('framed') === 0
        && String($(this).attr('data-option-available') || '').trim().toLowerCase() === 'false';
    }).first();
    if ($deadFrame.length) {
      var deadUnframedVal = String(window.mrk_unframed_value || 'Unframed').trim().toLowerCase();
      var $snapUnframed = $('variant-picker .variant-option--swatches input').filter(function () {
        return String($(this).val() || '').trim().toLowerCase() === deadUnframedVal;
      }).first();
      if ($snapUnframed.length && !$snapUnframed.is(':checked')) {
        mrkAutoCarriedFrame = false;
        $snapUnframed[0].dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    alreadyCheckedFrame();
    // The main variant-picker was just morphed by variant-picker.js: the swatch
    // wrappers (and their scroll/image-load bindings) may have been replaced and
    // the server render doesn't carry the .mrk-enable-controls state. Re-bind
    // and re-measure so the frame arrows survive every size/frame change.
    initSwatchSlider();
    if (!$('.mrk-frame-switcher input').length) {
      // Pure framed-print-only product (no frame-variant-picker rendered): the
      // alreadyCheckedFrame cascade above has nothing to trigger, so nothing
      // would re-run updateVariants after this change. Drive the frame image,
      // framing-service visibility and cart inputs directly.
      if ($('variant-picker').length) {
        updateProductPageFrame();
      } else {
        var frame_id = $('media-gallery .mrk-active-gallery-frame').data('frameId');
        if (frame_id) $('.mrk-frame-id').val(frame_id).prop('disabled', false);
      }
    }
  });
})();
// Track a REAL shopper frame pick (trusted event only - programmatic cascades
// don't count). drool-frame-default.js checks this flag to stop re-asserting
// the default preview frame once the shopper has chosen one.
$(document).on('change', 'variant-picker input[frame-color], .mrk-frame-switcher input, [name="framing-service"]', function (e) {
  if (!(e.originalEvent && e.originalEvent.isTrusted)) return;
  // Size radios also carry an (empty) frame-color attr, so attribute presence is
  // not enough — only a non-empty frame-color (a real frame swatch) counts.
  if ($(this).is('variant-picker input') && !String($(this).attr('frame-color') || '').trim()) return;
  window.__mrkFrameTouched = true;
});
$(document).on('change', '.mrk-frame-switcher input', updateProductPageFrame);
$(document).on('change', '[name="framing-service"]', updateProductPageFrame);
$(document).on('click', '.mrk-swatches-slider-wrapper .slideshow-control', function () {
  var $slider = $(this).closest('.mrk-swatches-slider-wrapper');
  var $wrapper = $slider.find('.mrk-swatches-wrapper');
  if ($wrapper.length === 0) return;

  // Step by one swatch; measure the clicked slider's own swatch (falls back to
  // ~80% of the visible width if it hasn't laid out yet, e.g. in a just-opened modal).
  var swatchWidth = $slider.find('.variant-option__button-label--has-swatch').first().outerWidth(true);
  var step = (swatchWidth || Math.round($wrapper.outerWidth() * 0.8) || 100) + 5;
  var current = $wrapper.scrollLeft();
  var target = $(this).attr('ref') === 'previous' ? current - step : current + step;

  $wrapper.stop(true).animate({ scrollLeft: target }, 100, updateSwatchArrows);
});

function updateFrame(){
  if ($('[name="mrk-collection-frame"]:checked').length) {
    var selected_frame = $('[name="mrk-collection-frame"]:checked').val().toLowerCase();
    $('.mrk-frame-image-item').hide();
    $('.mrk-collection-item-frames-wrapper').removeClass('mrk-collection-frame-item-active');
    $(`.mrk-frame-wrapper`).each(function () {
      if ($(this).find(`.mrk-frame-image-item[color="${selected_frame}"]`).length) {
        $(this).find(`.mrk-frame-image-item[color="${selected_frame}"]`).show();
        $(this).parents('.mrk-collection-item-frames-wrapper').addClass('mrk-collection-frame-item-active');
        // var url_item = $(this).parents('.boost-sd__product-link');
        // var url = $(url_item).attr('data-href') || $(url_item).attr('href');
        // var final_url = url + '?frame=' + selected_frame;
        // $(url_item).attr('href', final_url).attr('data-href', url)
      }
    })
  }
}
$(document).on('change', '[name="mrk-collection-frame"]', updateFrame);
$(document).on('click', '.mrk-detail-option-item', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $item = $(this);
  var $details = $item.closest('details');
  // `$el.closest(sel)` returns a jQuery OBJECT, and an empty jQuery object is still truthy — so
  // `||` never reached the fallback. Wherever this markup renders WITHOUT a <form> ancestor
  // (snippets/mrk-frame-cart-addon.liquid contains none of its own; it only works on the cart page
  // because cart-products.liquid happens to wrap it in one), $container was an empty set and every
  // .find() below silently did nothing: the hidden input never took the variant id and
  // .mrk-cart-frame-add stayed `disabled`. The label still updated — it uses $details — so the
  // shopper saw "+ Black Frame  +£30.80" selected and the frame was never added.
  //
  // .mrk-cart-frame-upsell is the addon's own root and holds BOTH the hidden input and the add
  // button, which is also what the submit handler (.mrk-cart-frame-add) already closes on — so
  // the two halves now agree on the same container regardless of any form.
  var $form = $item.closest('form');
  var $container = $form.length ? $form : $item.closest('.mrk-cart-frame-upsell');
  if (!$container.length) $container = $details;
  var $target = $details.find('.mrk-selected-detail-value').first();
  var content = $item.find('.upsell-dropdown-option').first().html() || $item.find('.addon-dropdown-option').first().html();

  if (!content || !$target.length) return;

  // Replace the selected area's content with the clicked option's content
  $target.html(content);

  // Close the <details>
  $details.prop('open', false);

  var variant = $(this).attr('value') || '',
    color = $(this).attr('color') || '',
    frame_id = $(this).attr('frame_id') || '',
    main_variant = $(this).attr('main-variant') || '',
    // Partner codes for the option just picked, as JSON from the variant metafields: the frame's,
    // or, on the framed-variant swap branch, that framed variant's own.
    frame_fulfilment = $(this).attr('data-wd-fulfilment') || '',
    // The print's framed variant for the same colour (framed Prodigi code and _frame), used when
    // the size is locked and the framing service is added along with the frame.
    framed_fulfilment = $(this).attr('data-wd-framed-fulfilment') || '';
  var $input = $container.find('[name="items[1][id]"]');
  if (variant === '') {
    $input.prop('disabled', true).val('');
    $container.find('.upsell-parent-id').prop('disabled', true);
    $container.find('.mrk-cart-frame-add').prop('disabled', true);
  } else {
    $input.prop('disabled', false).val(variant).attr('color', color).attr('main-variant', main_variant).attr('frame_id', frame_id).attr('data-wd-frame-fulfilment', frame_fulfilment).attr('data-wd-framed-fulfilment', framed_fulfilment);
    // Lock set on the print's framed variant for THIS colour (see isFramingServiceLocked).
    $input.attr('data-wd-option-locked', $item.attr('data-wd-option-locked') === 'true' ? 'true' : '');
    // Free framing set on the print's framed variant for THIS colour (see isFramingServiceFree).
    $input.attr('data-wd-option-free', $item.attr('data-wd-option-free') === 'true' ? 'true' : '');
    $container.find('.upsell-parent-id').prop('disabled', false);
    $container.find('.mrk-cart-frame-add').prop('disabled', false);
    $container.find('.mrk-upsell-frame-color').prop('disabled', false).val(color);
  }
});
$(document).on('click', function (e) {
  const $details = $('.mrk-custom-detail[open]');
  if ($details.length && !$(e.target).closest('.mrk-custom-detail').length) {
    $details.prop('open', false);
  }
});
$(document).on('click', '.mrk-cart-upsell-form .mrk-custom-detail summary', function () {
  const details = $(this).parents('details');

  setTimeout(() => {
    if (details.prop('open')) {
      const dropdown = details.find('.mrk-upsell-option-dropdown')[0];
      if (dropdown) {
        dropdown.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }, 50);
});

$(document).on('click', '.mrk-tab-trigger', function () {
  const frame = $(this).data('content');
  $('.mrk-tab-trigger').removeClass('tab-active');
  $(this).addClass('tab-active');
  $('.mrk-tab-content-item').hide();
  $(`.mrk-tab-content-item[frame="${frame}"]`).show();
});
$(document).on('click', '.mrk-tab-item-btn', function () {
  const section = $(this).parents('.shopify-section'),
    tab = $(this).data('tab');
  const html = $(this).next('template').html(),
    image = $(html).find('img'), srcset = $(image).data('srcset'), src = $(image).data('src');
  if (image != undefined) {
    $(section).find('.main-tab-image')
      .attr({ 'data-srcset': srcset, 'data-src': src })
      .removeAttr('src srcset')
      .removeClass('lazyloaded ls-is-cached')
      .addClass('lazyload');
  }
  $(section).find('.mrk-tab-item-btn').removeClass('mrk-tab-active');
  $(this).addClass('mrk-tab-active');
  $(section).find('.mrk-tab-content').hide();
  $(`.mrk-tab-content[data-tab="${tab}"]`).show();

});
$(document).on('click', '.mrk-cart-frame-add', function (e) {
  e.preventDefault();
  var $w = $(this).closest('.mrk-cart-frame-upsell');
  var childId = Number($w.find('.mrk-frame-cart-addon-id').val());
  var color = $w.find('.mrk-frame-cart-addon-id').attr('color');
  var parentId = Number($w.find('.mrk-frame-cart-addon-id').attr('parentVariant'));
  var frame_id = Number($w.find('.mrk-frame-cart-addon-id').attr('frame_id'));
  var main_variant = $w.find('.mrk-frame-cart-addon-id').attr('main-variant');
  var add_parent = $w.find('.mrk-frame-cart-addon-id').attr('addparent') == 'true';
  // This handler REBUILDS the print row, so its fulfilment properties are written back here. The
  // print's codes are rendered on the input; the frame's are stamped on it by the dropdown handler
  // above, because they depend on the colour chosen. Both are JSON read from variant metafields.
  var $addonInput = $w.find('.mrk-frame-cart-addon-id');
  var print_fd = droolReadFulfilment($addonInput, 'data-wd-print-fulfilment');
  var frame_fd = droolReadFulfilment($addonInput, 'data-wd-frame-fulfilment');
  // The print's framed variant for the chosen colour: framed Prodigi code and _frame.
  var framed_fd = droolReadFulfilment($addonInput, 'data-wd-framed-fulfilment');
  // A size marked custom.framing_service_locked holds no standalone frame, so a frame can only be
  // added there together with the framing service, never as an unassembled frame.
  var framing_locked = $addonInput.attr('data-wd-locked') === 'true' || $addonInput.attr('data-wd-option-locked') === 'true';
  // Free framing at this size + colour: assembled like a locked size, with the £0 framing service
  // (framing-service-1) in place of the paid one.
  var framing_free = $addonInput.attr('data-wd-free') === 'true' || $addonInput.attr('data-wd-option-free') === 'true';
  if (framing_free) framing_locked = true;
  var framing_service_id = Number($addonInput.attr('data-wd-framing-service-id')) || 0;
  var free_framing_service_id = Number($addonInput.attr('data-wd-free-framing-service-id')) || 0;
  if (framing_free) framing_service_id = free_framing_service_id;
  // The row as it is before this handler removes it, so a failed add can put it back.
  var original_qty = Number($addonInput.attr('data-wd-original-quantity')) || 1;
  var original_props = {};
  try { original_props = JSON.parse($addonInput.attr('data-wd-original-properties') || '{}') || {}; } catch (err) { original_props = {}; }
  // This row's line item key. /cart/change.js given the VARIANT id removes every line of that
  // variant: with the same print in the cart twice (one already framed), both lines went and only
  // this one was added back. The key removes this row only. Variant id stays as the fallback.
  var parentKey = $addonInput.attr('parentkey') || '';
  if (!parentId || !childId) return alert('Select main & sub variants');
  if (add_parent && framing_locked && !framing_free && !framing_service_id) {
    // Never build print + unassembled frame on a locked size. Leave the basket untouched instead.
    droolReportCartFailure('cart-frame-add-locked-no-service', 'framing-service product not found');
    return;
  }
  // One conversion at a time per row. assets/wd.js clicks this button as soon as a frame option is
  // chosen, which also leaves it enabled; a second press before the drawer redraws started a
  // second remove/add over the first and could double the line. Released on every exit below, and
  // by a timeout so a lost response can never leave the row stuck.
  if ($w.data('wdBusy')) return;
  $w.data('wdBusy', true);
  var releaseBusy = function () { $w.removeData('wdBusy'); };
  setTimeout(releaseBusy, 12000);
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  // 1️⃣ Remove parent variant first
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: parentKey || parentId, quantity: 0 },
    dataType: 'json'
  }).always(function () {
    // 2️⃣ Build items array based on whether main-variant exists
    var items;
    if (add_parent) {
      // Print + frame. Normally there is no framing service: scenario 3, two items, each row with
      // its own partner codes. On a locked size the service is added too: scenario 2, one item.
      // $.extend adds the codes to the existing properties without touching those. Quantities keep
      // the row's own quantity rather than resetting it to 1.
      var parentProps = { 'Color': color, '_main_variant': Number(main_variant), '_frame_id': frame_id };
      var frameLine = { id: childId, quantity: original_qty, parent_id: parentId };
      items = [
        { id: parentId, quantity: original_qty, properties: parentProps },
        frameLine
      ];
      if (framing_locked && !window.drool_three_line_cart && Number(main_variant)) {
        // Today's shape on a locked size: the print's own framed variant (the option's main-variant)
        // + the framing service, with that variant's codes. No loose frame line.
        var swapProps = { 'Color': color, '_frame_id': frame_id };
        if (print_fd) {
          $.extend(swapProps, droolWithRowType(droolRowProps({
            _prodigi_sku: (framed_fd && framed_fd.p) || print_fd.pf || '',
            _alf_sku: (framed_fd && framed_fd.a) || print_fd.a,
            _frame: (frame_fd && frame_fd.f) || (framed_fd ? framed_fd.f : '')
          }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print'));
        }
        var swapService = { id: framing_service_id, quantity: original_qty, parent_id: Number(main_variant) };
        if (print_fd) swapService.properties = droolIgnoreProps();
        items = [
          { id: Number(main_variant), quantity: original_qty, properties: swapProps }
        ];
        if (framing_service_id) items.push(swapService);
      } else if (framing_locked) {
        if (print_fd) {
          $.extend(parentProps, droolWithRowType(droolRowProps({
            _prodigi_sku: print_fd.pf || (framed_fd && framed_fd.p) || '',
            _alf_sku: print_fd.a,
            _frame: (frame_fd && frame_fd.f) || (framed_fd ? framed_fd.f : '')
          }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print'));
          frameLine.properties = droolIgnoreProps();
        }
        var serviceLine = { id: framing_service_id, quantity: original_qty, parent_id: parentId };
        if (print_fd) serviceLine.properties = droolIgnoreProps();
        if (framing_service_id) items.push(serviceLine);
      } else if (print_fd) {
        $.extend(parentProps, droolWithRowType(droolRowProps({ _prodigi_sku: print_fd.p, _alf_sku: print_fd.a }, ['_prodigi_sku', '_alf_sku']), 'print'));
        frameLine.properties = droolStandaloneFrameProps(frame_fd);
      }
    } else {
      // Swaps the line for one of the print's own framed variants (frame built in): one row, one
      // item. It carries that variant's own codes, stamped onto the input from the chosen option,
      // exactly as the product page writes the same variant. No data on the option means nothing
      // is written.
      var soloProps = { 'Color': color };
      if (frame_fd) {
        $.extend(soloProps, droolWithRowType(droolRowProps({ _prodigi_sku: frame_fd.p, _alf_sku: frame_fd.a, _frame: frame_fd.f }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print'));
      }
      items = [
        { id: childId, quantity: original_qty, properties: soloProps }
      ];
      // Free framing on the size: the framed variant carries the £0 framing service, as on the
      // product page.
      if (framing_free && free_framing_service_id) {
        var soloService = { id: free_framing_service_id, quantity: original_qty, parent_id: Number(childId) };
        if (frame_fd) soloService.properties = droolIgnoreProps();
        items.push(soloService);
      }
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items: items, sections: sectionIds }
    }).then(function (response) {
      releaseBusy();
      window.manualCartRefresh(response);
    }, function (xhr) {
      // The print was already removed above. Put it back exactly as it was, so a failed add never
      // silently empties the row, and report the failure.
      droolReportCartFailure('cart-frame-add', xhr);
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { items: [{ id: parentId, quantity: original_qty, properties: original_props }], sections: sectionIds }
      }).then(function (restored) {
        releaseBusy();
        window.manualCartRefresh(restored);
      }, function (restoreXhr) {
        releaseBusy();
        droolReportCartFailure('cart-frame-add-restore', restoreXhr);
      });
    });
  });
});
$(document).on('click', '[href="#open-cart"]', function (e) {
  e.preventDefault();
  $('.mrk-cart-icon-button').trigger('click');
})
$(document).on('click', '.mrk-cart-framing-add', function (e) {
  e.preventDefault();

  const $btn = $(this);
  let parentId = Number($btn.attr('parent')) || 0;
  let childId = Number($btn.attr('frame')) || 0;
  // A line carrying a fulfilment code was built by the new system, so finish it the same way the
  // product page would: unframed print + frame child + service, three lines. The legacy branch
  // below swaps to the print's own assembled framed variant and drops the frame line, which gave
  // the drawer a different cart shape from the product page for the same shopper choice.
  // Lines with no code keep the legacy behaviour untouched.
  // One conversion at a time per button (same reason as the add-frame handler above).
  if ($btn.data('wdBusy')) return;
  $btn.data('wdBusy', true);
  const releaseBusy = function () { $btn.removeData('wdBusy'); };
  setTimeout(releaseBusy, 12000);
  const keep_child_frame = $btn.attr('keep_child_frame') === 'true';
  if (!keep_child_frame && Number($btn.attr('main_variant'))) {
    parentId = Number($btn.attr('main_variant'));
    childId = null;
  }
  const quantity = Number($btn.attr('quantity')) || 1;
  const framingServiceId = Number($btn.attr('framing')) || 0;
  const color = $btn.attr('color') || '';
  const frame_id = $btn.attr('frame_id') || '';
  // Adding the framing service makes the print, the frame and the service ONE item to make
  // (scenario 2). The snippet renders each variant's partner codes from its metafields. Only the
  // three-row shape (keep_child_frame) writes them: the legacy branch above swaps to the print's
  // own framed variant for rows that predate this system, and writes nothing.
  // Codes are written on BOTH shapes, but only when the product page wrote them on this row
  // (data-wd-props): the properties switch and the structure switch are independent.
  const props_on = $btn.attr('data-wd-props') === 'true';
  const print_fd = props_on ? droolReadFulfilment($btn, 'data-wd-print-fulfilment') : null;
  const framed_fd = props_on ? droolReadFulfilment($btn, 'data-wd-framed-fulfilment') : null;
  // The print's framed variant for the chosen colour (= _main_variant, the row the legacy shape
  // swaps to). _frame prefers the child frame the customer picked (frame_fd), then this.
  const colour_fd = props_on ? droolReadFulfilment($btn, 'data-wd-colour-fulfilment') : null;
  const frame_fd = props_on ? droolReadFulfilment($btn, 'data-wd-frame-fulfilment') : null;
  const itemsToRemove = ($btn.attr('item-to-remove') || '').split(',');

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map(el => el.dataset.sectionId)
    .filter(Boolean);

  const updates = {};
  itemsToRemove.forEach(id => { updates[id] = 0; });
  const removePromise = Object.keys(updates).length
    ? $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: { updates }
    })
    : $.Deferred().resolve().promise();

  removePromise.always(function () {
    const items = [];

    if (parentId) {
      const props = {};
      if (color) props['Framing'] = color;
      if (frame_id) props['_frame_id'] = frame_id;
      if (print_fd && keep_child_frame) {
        // Three-line shape: the print row stays the unframed variant, assembled by us.
        $.extend(props, droolWithRowType(droolRowProps({
          _prodigi_sku: print_fd.pf || (colour_fd && colour_fd.p) || (framed_fd ? framed_fd.p : ''),
          _alf_sku: print_fd.a,
          _frame: (frame_fd && frame_fd.f) || (colour_fd ? colour_fd.f : '')
        }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print'));
      } else if (print_fd) {
        // Today's shape: parentId is the print's own framed variant (_main_variant), so the row
        // carries that variant's codes.
        $.extend(props, droolWithRowType(droolRowProps({
          _prodigi_sku: (colour_fd && colour_fd.p) || print_fd.pf || (framed_fd ? framed_fd.p : ''),
          _alf_sku: (colour_fd && colour_fd.a) || print_fd.a,
          _frame: (frame_fd && frame_fd.f) || (colour_fd ? colour_fd.f : '')
        }, ['_prodigi_sku', '_alf_sku', '_frame']), 'framed_print'));
      }
      items.push({ id: parentId, quantity: quantity, properties: props });
    }
    if (childId && parentId) {
      const frameLine = { id: childId, quantity: quantity, parent_id: parentId };
      // IGNORE is explicit on a skipped row: an absent property sends the partner to the frame
      // variant's own metafield, and they would ship a standalone frame.
      if (print_fd) frameLine.properties = droolIgnoreProps();
      items.push(frameLine);
    }
    if (framingServiceId && parentId) {
      const serviceLine = { id: framingServiceId, quantity: quantity, parent_id: parentId };
      if (print_fd) serviceLine.properties = droolIgnoreProps();
      items.push(serviceLine);
    }

    if (!items.length) { releaseBusy(); return; }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items,
        sections: sectionIds
      }
    }).then(function (response) {
      releaseBusy();
      if (typeof window.manualCartRefresh === 'function') {
        window.manualCartRefresh(response);
      }
    }, function (xhr) {
      // The print and frame rows were already removed above. Put them back as they were, so a
      // failed add never silently empties them, and report the failure.
      droolReportCartFailure('cart-framing-add', xhr);
      let restore = null;
      try { restore = JSON.parse($btn.attr('data-wd-restore') || 'null'); } catch (err) { restore = null; }
      if (!Array.isArray(restore) || !restore.length) { releaseBusy(); return; }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { items: restore, sections: sectionIds }
      }).then(function (restored) {
        releaseBusy();
        if (typeof window.manualCartRefresh === 'function') window.manualCartRefresh(restored);
      }, function (restoreXhr) {
        releaseBusy();
        droolReportCartFailure('cart-framing-add-restore', restoreXhr);
      });
    });
  });
});
$(document).on('cart:update cart:updated', function (e) {
  if (syncing) return;
  syncing = true;

  var changedInputs = [];
  var processed = new Set(); // to skip inputs we've handled via grouping

  // 1) Loop each parent line
  $('.cart-items__table-row[data-key]').each(function () {
    var $parent = $(this);
    var parentKey = $parent.attr('data-key');
    if (!parentKey) return;

    var $parentInput = $parent.find('input[name="updates[]"]');
    if (!$parentInput.length) return;

    var pQty = parseInt($parentInput.val(), 10) || 0;

    // 2) Find all children of this parent
    var $children = $('.cart-items__table-row[data-parent-key="' + parentKey + '"]');

    if (!$children.length) return;

    // Helper: extract variant id from data-key (before the first ":")
    var getVariantId = function ($row) {
      var key = $row.attr('data-key') || '';
      var idx = key.indexOf(':');
      return idx > -1 ? key.slice(0, idx) : key; // fall back to full key if no colon
    };

    // 3) Group children by variant id
    var groups = {};
    $children.each(function () {
      var $child = $(this);
      var $childInput = $child.find('input[name="updates[]"]');
      if (!$childInput.length) return;

      var vId = getVariantId($child);
      groups[vId] = groups[vId] || { inputs: [], sum: 0 };
      groups[vId].inputs.push($childInput);
      groups[vId].sum += (parseInt($childInput.val(), 10) || 0);
    });

    // 4) For each group:
    //    - if same variant appears in multiple lines, compare the SUM to the parent
    //    - if mismatch, set first to parent qty and zero-out the rest (keeps totals correct)
    //    - if only one line for that variant, fall back to the old 1:1 behavior
    Object.keys(groups).forEach(function (vId) {
      var g = groups[vId];

      if (g.inputs.length > 1) {
        // Multi-line split for the same variant (discount, promo, etc.)
        if (g.sum !== pQty) {
          // Put the full qty on the first line and zero-out others
          g.inputs.forEach(function ($input, idx) {
            var target = (idx === 0) ? pQty : 0;
            if ((parseInt($input.val(), 10) || 0) !== target) {
              $input.val(target);
              changedInputs.push($input[0]);
            }
            processed.add($input[0]);
          });
        } else {
          // Totals already match parent; mark as processed so we don't touch them again
          g.inputs.forEach(function ($input) {
            processed.add($input[0]);
          });
        }
      } else {
        // Single child line for this variant: keep the original 1:1 sync
        var $only = g.inputs[0];
        var cQty = parseInt($only.val(), 10) || 0;
        if (cQty !== pQty) {
          $only.val(pQty);
          changedInputs.push($only[0]);
        }
        processed.add($only[0]);
      }
    });
  });
  // 5) Still handle other (non-duplicate) child rows that weren’t processed above
  $('.cart-items__table-row[data-parent-key!=""]').each(function () {
    var $child = $(this);
    var $childInput = $child.find('input[name="updates[]"]');
    if (!$childInput.length) return;
    if (processed.has($childInput[0])) return; // already handled via grouping

    var parentKey = $child.attr('data-parent-key');
    var $parent = $('.cart-items__table-row[data-key="' + parentKey + '"]');
    if (!$parent.length) return;

    var $parentInput = $parent.find('input[name="updates[]"]');
    if (!$parentInput.length) return;

    var pQty = parseInt($parentInput.val(), 10) || 0;
    var cQty = parseInt($childInput.val(), 10) || 0;

    if (pQty !== cQty) {
      $childInput.val(pQty);
      changedInputs.push($childInput[0]);
    }
  });

  // 6) Fire events for anything we changed (covers custom listeners)
  if (changedInputs.length) {
    changedInputs.forEach(function (el) {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  }


  syncing = false;
  mrkApplyGiftAdjustments()
});
$(document).on('click', '.mrk-custom-linked a', function (e) {
  e.preventDefault();
  var url = $(this).attr('href'),
  selected_size = $('.mrk-selected-option .mrk-size-item-title').text().trim(),
  selected_frame = $('frame-variant-picker .mrk-swatches-wrapper input:checked').attr('frame-color')?.toLowerCase() || $('variant-picker .mrk-swatches-wrapper input:checked').attr('frame-color').toLowerCase(),
  url = url + '?frame=' + selected_frame + '&size=' + selected_size;
  location.href = url;
})
// Shared product-form bootstrap. Runs once on PDP page-load AND again each time
// the quick-add modal injects a product (see window.mrkInitQuickAdd) so framing
// mode, swatch slider, availability filtering and the initial frame image all
// initialise identically in both contexts. Single source of truth - the modal
// reuses the exact same code paths as the PDP, nothing is duplicated.
function mrkBootstrapProductForm() {
  RemoveUnavailableVariants();
  // Bootstrap framing-mode body class FIRST so the size-specific CSS overrides
  // (frame-variant-picker hidden, framing-service hidden, and crucially the
  // FPO main-picker frame swatches shown) apply BEFORE the slider measures
  // overflow. Otherwise those swatches are still display:none when
  // initSwatchSlider runs, the slider is skipped as "hidden", and the scroll
  // arrows never appear.
  if ($('#mrk-main-variant-data').length) {
    var bootstrap_main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
    var bootstrap_mode = getFramingMode(bootstrap_main_variant);
    $('body').toggleClass('mrk-fpo-active', bootstrap_mode === 'Framed print only');
    // Seed the prev-framing-mode tracker so the FIRST user-triggered
    // mrkVariantChanged has a correct previous mode.
    if (typeof window.__mrkSeedPrevFramingMode === 'function') {
      window.__mrkSeedPrevFramingMode(bootstrap_mode);
    }
  }
  initSwatchSlider();
  if ($('frame-variant-picker input').length && $('variant-picker input:checked:eq(0)').val() != $('frame-variant-picker input:checked:eq(0)').val()) {
    $('variant-picker input:checked:eq(0)')[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (window.show_default_black_variant) {
    $('[color="black"]').show().addClass('mrk-active-gallery-frame');
  }
}

// Entry point called by quick-add.js after the product-information section is
// injected into the quick-add modal. quick-add.js re-executes the inline data
// <script>s (window.main_product_data, the framing globals, #mrk-main-variant-data,
// etc.) BEFORE calling this, so getFramingMode/updateVariants see this product's
// data. On a collection page the modal is the only PDP context, so the
// unscoped selectors above resolve to the modal content.
window.mrkInitQuickAdd = function () {
  mrkBootstrapProductForm();
  // Unlike the PDP (which lets user interaction cascade), prime price, frame
  // image and the hidden cart inputs immediately so an add-to-bag with no
  // interaction still submits the correct variant + frame/service line items.
  if (typeof updateProductPageFrame === 'function') updateProductPageFrame();
};

$(function () {
  const frameColor = new URLSearchParams(window.location.search).get('frame');
  const selectedSize = new URLSearchParams(window.location.search).get('size');
  if (frameColor) {
    $('.mrk-swatches-wrapper [frame-color="' + frameColor + '"]').prop('checked', true).trigger('change');
    if ($('.mrk-swatches-wrapper').length) {
      document.dispatchEvent(new CustomEvent('mrkBeforeVariantChanged', {
        detail: $('.mrk-size-item-main input:checked').data('value')
      }));
    }
  }
  if (selectedSize) {
    $(`.mrk-size-item-main [data-value='${selectedSize}']`).prop('checked', true)[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
  var frame = $('.mrk-frame-switcher input:checked');
  if ($(frame).length) {
    $('.mrk-frame-color').val($(frame).val()).prop('disabled', false);
  }
  initStickyAddToCart();
  // We do NOT call updateVariants() here - the legacy code paths trigger it
  // through their own cascade, and calling it eagerly causes the picker to
  // re-fetch and feel like the page is reloading.
  mrkBootstrapProductForm();
  droolPrimeFulfilmentInputs();
  const params = new URLSearchParams(window.location.search);
  if (params.has('open-cart') || window.location.hash == '#open-cart') {
    $('cart-drawer-component .header-actions__action').trigger('click');
  }
});